import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import _ from "lodash";

const UISwipeableDrawer = (props) => {
  const apptheme = useSelector((state) => state.app?.theme);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props?.setOpen(open);
  };

  const paperStyles = {
    borderRadius: props?.borderRadiusNone || "20px 0px 0px 20px",
    background: apptheme === "light" ? "#fff" : "#2D2C5A",
    width: isMdUp ? props?.width || "25%" : props?.width || "95%",
    overflowX: "hidden",
  };

  return (
    <SwipeableDrawer
      anchor={_.get(props, "anchor", "right")}
      open={_.get(props, "open", false)}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      PaperProps={{
        sx: paperStyles,
      }}
    >
      {props?.appBar !== false && (
        <AppBar
          sx={{
            position: "relative",
            background: apptheme === "dark" ? "#202529" : "#237FEA",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="primary"
              onClick={toggleDrawer(false)}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {_.get(props, "title", "")}
            </Typography>
          </Toolbar>
        </AppBar>
      )}
      <Box sx={{ padding: props?.padding || "15px" }}>
        {_.get(props, "jsx", <></>)}
      </Box>
    </SwipeableDrawer>
  );
};

export default UISwipeableDrawer;
